/**
 * Lifecycle status of a creator-owned social account. This model is
 * deliberately password/token/cookie-free: the platform only ever stores
 * safe metadata that can be observed from the device (username, display
 * name, avatar) plus health signals derived from the UI.
 */
export var SocialAccountStatus;
(function (SocialAccountStatus) {
    /** Account is logged in and the session is believed to be usable. */
    SocialAccountStatus["CONNECTED"] = "CONNECTED";
    /** The device is showing a login screen for this platform. */
    SocialAccountStatus["LOGIN_REQUIRED"] = "LOGIN_REQUIRED";
    /** Session is stale (e.g. token expiry detected by the platform). */
    SocialAccountStatus["EXPIRED"] = "EXPIRED";
    /** Explicitly logged out by the user or the platform. */
    SocialAccountStatus["LOGGED_OUT"] = "LOGGED_OUT";
    /** A second-factor challenge is blocking access. */
    SocialAccountStatus["TWO_FA_REQUIRED"] = "2FA_REQUIRED";
    /** Account is locked/disabled by the platform. */
    SocialAccountStatus["LOCKED"] = "LOCKED";
    /** Could not be determined (device offline, analysis failed, etc.). */
    SocialAccountStatus["UNKNOWN"] = "UNKNOWN";
})(SocialAccountStatus || (SocialAccountStatus = {}));
/** Lifecycle of a device-native connect/reconnect session. */
export var ConnectSessionStatus;
(function (ConnectSessionStatus) {
    /** Created, app not launched yet. */
    ConnectSessionStatus["PENDING"] = "PENDING";
    /** Waiting for the user to finish logging in on the device. */
    ConnectSessionStatus["AWAITING_LOGIN"] = "AWAITING_LOGIN";
    /** Login detected; verifying the connected account. */
    ConnectSessionStatus["VERIFYING"] = "VERIFYING";
    /** Verified — a SocialAccount row was created/updated. */
    ConnectSessionStatus["CONNECTED"] = "CONNECTED";
    /** Verification failed (app missing, unexpected screen, etc.). */
    ConnectSessionStatus["FAILED"] = "FAILED";
    /** The user did not finish logging in within the timeout. */
    ConnectSessionStatus["TIMED_OUT"] = "TIMED_OUT";
    /** Cancelled by the user. */
    ConnectSessionStatus["CANCELLED"] = "CANCELLED";
})(ConnectSessionStatus || (ConnectSessionStatus = {}));
export var SocialAuditEventType;
(function (SocialAuditEventType) {
    SocialAuditEventType["ACCOUNT_CONNECTED"] = "ACCOUNT_CONNECTED";
    SocialAuditEventType["ACCOUNT_RECONNECTED"] = "ACCOUNT_RECONNECTED";
    SocialAuditEventType["ACCOUNT_LOGGED_OUT"] = "ACCOUNT_LOGGED_OUT";
    SocialAuditEventType["ACCOUNT_REMOVED"] = "ACCOUNT_REMOVED";
    SocialAuditEventType["ACCOUNT_STATUS_CHANGED"] = "ACCOUNT_STATUS_CHANGED";
    SocialAuditEventType["AUTOMATION_FAILED_LOGIN_REQUIRED"] = "AUTOMATION_FAILED_LOGIN_REQUIRED";
    SocialAuditEventType["CONNECT_SESSION_FAILED"] = "CONNECT_SESSION_FAILED";
    /** The connect/reconnect flow could not establish or match the authenticated identity. */
    SocialAuditEventType["IDENTITY_VERIFICATION_FAILED"] = "IDENTITY_VERIFICATION_FAILED";
    SocialAuditEventType["HEALTH_CHECK"] = "HEALTH_CHECK";
})(SocialAuditEventType || (SocialAuditEventType = {}));
//# sourceMappingURL=social-account.types.js.map